// extracted by mini-css-extract-plugin
module.exports = {"summary__item":"L_db","summary__item__name":"L_dc","summary__item__price":"L_dd","summary__col__wrap":"L_df","summary__quantity":"L_dg"};